// 公共商品数据
export const allProducts = [
  // Sopuria Products
  {
    id: 41,
    name: 'Ubox / Upod',
    img: require('@/assets/img/product-atomizer-sopuria-Ubox_Upod.jpg'),
    description: 'product_desc_41',
    category: 'product_category_sopuria',
    features: ['feature_pod', 'feature_rechargeable']
  },
  {
    id: 42,
    name: 'SUBOX',
    img: require('@/assets/img/product-atomizer-sopuria-SUBOX.jpg'),
    description: 'product_desc_42',
    category: 'product_category_sopuria',
    features: ['feature_disposable', 'feature_adjustable_airflow']
  },
  {
    id: 43,
    name: 'Eilbar Pro',
    img: require('@/assets/img/product-atomizer-sopuria-EilbarPro.jpg'),
    description: 'product_desc_43',
    category: 'product_category_sopuria',
    features: ['feature_disposable', 'feature_adjustable_airflow']
  },
  {
    id: 44,
    name: 'EVODBAR',
    img: require('@/assets/img/product-atomizer-sopuria-EVODBAR.jpg'),
    description: 'product_desc_44',
    category: 'product_category_sopuria',
    features: ['feature_pod']
  },
  {
    id: 45,
    name: 'ARYMI',
    img: require('@/assets/img/product-atomizer-sopuria-ARYMI.jpg'),
    description: 'product_desc_45',
    category: 'product_category_sopuria',
    features: ['feature_disposable', 'feature_adjustable_airflow']
  },
  {
    id: 46,
    name: 'Litdrop',
    img: require('@/assets/img/product-atomizer-sopuria-Litdrop.jpg'),
    description: 'product_desc_46',
    category: 'product_category_sopuria',
    features: ['feature_disposable', 'feature_adjustable_airflow']
  },
  // Kangertech Products
  {
    id: 51,
    name: 'DRIP BOX',
    img: require('@/assets/img/product-atomizer-kangertech-DRIP_BOX.jpg'),
    description: 'product_desc_51',
    category: 'product_category_kangertech',
    features: ['feature_box_mod', 'feature_rechargeable']
  },
  {
    id: 52,
    name: 'KR30000',
    img: require('@/assets/img/product-atomizer-kangertech-KR30000.jpg'),
    description: 'product_desc_52',
    category: 'product_category_kangertech',
    features: ['feature_disposable']
  },
  {
    id: 53,
    name: 'ULTRA BAR',
    img: require('@/assets/img/product-atomizer-kangertech-ULTRA_BAR.jpg'),
    description: 'product_desc_53',
    category: 'product_category_kangertech',
    features: ['feature_disposable']
  },
  {
    id: 54,
    name: 'U Pod',
    img: require('@/assets/img/product-atomizer-kangertech-U_Pod.jpg'),
    description: 'product_desc_54',
    category: 'product_category_kangertech',
    features: ['feature_pod', 'feature_rechargeable', 'feature_adjustable_airflow']
  },
  {
    id: 55,
    name: 'Unibar',
    img: require('@/assets/img/product-atomizer-kangertech-Unibar.jpg'),
    description: 'product_desc_55',
    category: 'product_category_kangertech',
    features: ['feature_disposable', 'feature_adjustable_airflow']
  },
  {
    id: 56,
    name: 'TOGO mini',
    img: require('@/assets/img/product-atomizer-kangertech-TOGO_mini.jpg'),
    description: 'product_desc_56',
    category: 'product_category_kangertech',
    features: ['feature_disposable', 'feature_pod']
  },
  {
    id: 57,
    name: 'Protank Bar',
    img: require('@/assets/img/product-atomizer-kangertech-Protank_Bar.jpg'),
    description: 'product_desc_57',
    category: 'product_category_kangertech',
    features: ['feature_box_mod', 'feature_tank', 'feature_adjustable_airflow', 'feature_power_display']
  },
  {
    id: 58,
    name: 'Top Tank',
    img: require('@/assets/img/product-atomizer-kangertech-Top_Tank.jpg'),
    description: 'product_desc_58',
    category: 'product_category_kangertech',
    features: ['feature_tank', 'feature_rechargeable', 'feature_refillable', 'feature_smart_puff_sync']
  },
  {
    id: 59,
    name: 'SUBOX MINI',
    img: require('@/assets/img/product-atomizer-kangertech-SUBOX_MINI.jpg'),
    description: 'product_desc_59',
    category: 'product_category_kangertech',
    features: ['feature_three_modes', 'feature_pod', 'feature_adjustable_airflow', 'feature_rechargeable', 'feature_child_lock']
  }
  // 其他商品可以继续添加
];